import { notify } from 'react-notify-toast';

import CustomerStore from "./store.js";
import api from '../../services/api';

export const createOrUpdate = async customer => {
    CustomerStore.isLoading = true;
    try {
        await api.post("/api/v1/customers/", customer);
        notify.show('Salvo com sucesso', 'success');
    } catch (error) {
        const response = error.response;
        let message = '';
        if (response.status === 401){
            notify.show("Sua sessão expirou, logar novamente", 'error');
        } else if (response.data){
            Object.keys(response.data).forEach( key_ => {
                if (key_ !== 'user'){
                    message = `${message} Campo: ${key_}: `
                    response.data[key_].forEach(i => message = `${message}; ${i}`)
                }else{
                    Object.keys(response.data[key_]).forEach(k=>{
                        message = `${message} Campo: ${k}: `
                        response.data[key_][k].forEach(i => message = `${message}; ${i}`)
                    });
                }
            });
            notify.show(message, 'error', 8000);
        }
        console.error(error)
    } finally {
        CustomerStore.isLoading = false;
    }
}


export const getProfessions =  async () => {
    let data = []

    try {

        data = await (await api.get('/api/v1/professions/')).data;
    } catch (error) {
        console.error(error)
    }

    return data;
}

export const getwhoIndicated =  async (name) => {
    let data = []

    try {
        data = await (await api.get(`/api/v1/who_indicated/?username=${name}`)).data;
    } catch (error) {
        console.error(error)
    }

    return data;
}

export const getAddressByCEP = async cep => {
	let data = null

    try {

        data = await (await api.get(`/api/v1/addresses/search/${cep}`)).data;
    } catch (error) {
        console.error(error)
    }

    return data;
}
